import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-likert',
  templateUrl: './likert.component.html',
  styleUrls: ['./likert.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LikertComponent),
      multi: true
    }
  ]
})
export class LikertComponent implements ControlValueAccessor {

  @Input() values: string[] = ['1', '2', '3', '4', '5'];
  @Input() value: string;
  @Input() minLabelText: string;
  @Input() maxLabelText: string;
  @Output() selection = new EventEmitter<string>();

  protected colorsTable: string[] = [
    "bg-danger",
    "bg-amber",
    "bg-warning",
    "bg-green-yellow",
    "bg-success"
  ];

  protected onChange: any = () => { }
  protected onTouch: any = () => { }

  onStepClick(val: string) {
    if (val !== this.value) {
      this.writeValue(val);
      this.selection.emit(val);
    }
  }

  writeValue(val: any): void {
    if (val !== undefined && val !== null && this.value !== val) {
      this.value = val;
      this.onChange(this.value);
      this.onTouch(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  protected activeColor(value: string) {
    return this.colorsTable.at(this.values.indexOf(value)) || 'bg-primary';
  }

}
